import React from "react";
var __jsx = React.createElement;
var ContactSVG = function ContactSVG(_ref) {
  var _ref$filledColor = _ref.filledColor,
    filledColor = _ref$filledColor === void 0 ? "white" : _ref$filledColor;
  return /*#__PURE__*/React.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.1939 8.0281C1.9319 8.0281 2.6459 7.9081 3.3119 7.6921C3.5219 7.6201 3.7559 7.6741 3.9179 7.8361L4.8599 9.0181C6.5579 8.2081 8.1479 6.6781 8.9939 4.9201L7.8239 3.9241C7.6619 3.7561 7.6139 3.5221 7.6799 3.3121C7.9019 2.6461 8.0159 1.9321 8.0159 1.1941C8.0159 0.870098 8.2859 0.600098 8.6099 0.600098H10.6859C11.0099 0.600098 11.3999 0.744098 11.3999 1.1941C11.3999 6.7681 6.7619 11.4001 1.1939 11.4001C0.767903 11.4001 0.599903 11.0221 0.599903 10.6921V8.6221C0.599903 8.2981 0.869904 8.0281 1.1939 8.0281Z",
    fill: filledColor
  }));
};
export default ContactSVG;